import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Key } from '../models/key.model';

@Injectable()
export class KeyService {
  public constructor(private http: HttpClient) {}

  public create(data: Key) {
    return this.http.post(`${environment.apiUrl}/keys`, data);
  }
  public update(id: string, data: Key) {
    return this.http.put(`${environment.apiUrl}/keys/${id}`, data);
  }
  public delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/keys/${id}`);
  }
  public show(id: string) {
    return this.http.get(`${environment.apiUrl}/keys/${id}`);
  }
  public showAll(params: any = {}) {
    return this.http.get(`${environment.apiUrl}/keys`, {
      params: params
    });
  }
}
